/**
 * 入驻材料的类型(营业执照 / 运输资质)。**单点定义在这里,三端引用**
 * (CLAUDE.md 硬约束「枚举单点定义」)。
 *
 * ── 它为什么存在(2026-10-11 人裁决)────────────────────────────
 *
 * 申请页从 S-24 起就有两个标好的上传位,但库里只存了一个对象键数组 ——
 * 审核人点开详情看到的是「材料 1 / 材料 2」,不知道哪张是营业执照。AS-063 当年
 * 选了「按顺序列出、不标类型」,并写明「真要类型化的话,正确路径是给申请表加一列
 * 材料类型,而不是解析对象键的文件名」。这一列就是那句话的兑现。
 *
 * ── 为什么不解析对象键里的 license- / permit- 前缀 ─────────────
 *
 * 键名是**客户端拼的**:客户端改一次命名,标注就静默错位 —— 错标比不标危险
 * (审核人会把运输资质当营业执照看)。类型必须随材料一起提交,由服务端原样落库。
 *
 * prisma/schema.prisma 里有一份同名的数据库枚举(CarrierMaterialType),那是
 * 不得不有的第二处 —— 数据库需要自己的类型定义。两处的一致性不靠人记得:
 * apps/api/src/common/enum-parity.ts 里有一条类型级断言,两边一旦对不上,
 * `pnpm typecheck` 直接失败(typecheck 守卫会红)。
 */
export const CARRIER_MATERIAL_TYPE = ['business_license', 'transport_permit'] as const

export type CarrierMaterialType = (typeof CARRIER_MATERIAL_TYPE)[number]

export function isCarrierMaterialType(x: unknown): x is CarrierMaterialType {
  return typeof x === 'string' && (CARRIER_MATERIAL_TYPE as readonly string[]).includes(x)
}
